<div class="multipoint-business-name-pymes">
  <div class="multipoint-business-name-pymes__header">
    <h2>{{ 'HOME.BUSINESS_NAME' | i18nextEager }}</h2>
    <span class="multipoint-business-name-pymes__required">* {{ 'COMMONS.REQUIRED' | i18nextEager }}</span>
  </div>
  <section>
    <h2>{{ 'NEW_CONTRACTS.MAIN_DATA' | i18nextEager }}</h2>
    <form [formGroup]="businessNameForm">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.MULTIPOINT.DOCUMENT_NUMBER' | i18nextEager }}</mat-label>
        <input
          matInput
          formControlName="numberDocument"
          maxlength="9"
          placeholder="{{ isUserSpanish ? ('NEW_CONTRACTS.CIF_EXAMPLE' | i18nextEager) : '' }}"
        />
        <mat-error
          *ngIf="
            businessNameForm?.controls.numberDocument.errors?.required &&
            (businessNameForm.controls.numberDocument.touched || businessNameForm.controls.numberDocument.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
        <mat-error
          *ngIf="
            businessNameForm?.controls.numberDocument.errors?.invalid_cif &&
            (businessNameForm.controls.numberDocument.touched || businessNameForm.controls.numberDocument.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.CIF_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <div class="multipoint-business-name-pymes__container-field">
        <span class="multipoint-business-name-pymes__title-field multipoint-business-name-pymes__title-field--button">
          {{ 'RENOVATE_COTRACT.CREDIT_ANALYSIS' | i18nextEager | uppercase }}
        </span>
        <div class="multipoint-business-name-pymes__container-label">
          <ng-container *ngIf="approved && callQuery">
            <img src="/assets/icons/approved.svg" alt="{{ 'RENOVATE_COTRACT.APPROVED' | i18nextEager }}" />
            <span class="multipoint-business-name-pymes__label">{{ 'RENOVATE_COTRACT.APPROVED' | i18nextEager }}</span>
          </ng-container>
          <ng-container *ngIf="!approved && callQuery">
            <img src="/assets/icons/rejected.svg" alt="{{ 'RENOVATE_COTRACT.REJECTED' | i18nextEager }}" />
            <span class="multipoint-business-name-pymes__label">{{ 'RENOVATE_COTRACT.REJECTED' | i18nextEager }}</span>
          </ng-container>
          <button
            class="multipoint-business-name-pymes__button"
            (click)="handleQuery()"
            [disabled]="callQuery || this.businessNameForm.get('numberDocument').invalid"
          >
            {{ 'RENOVATE_COTRACT.QUERY' | i18nextEager }}
          </button>
        </div>
      </div>
      <mat-form-field
        appearance="outline"
        [ngClass]="{
          'multipoint-business-name-pymes__fix-label':
            businessNameForm?.controls.socialReasonLabel.errors?.required &&
            !(businessNameForm.controls.socialReasonLabel.touched || businessNameForm.controls.socialReasonLabel.dirty)
        }"
      >
        <mat-label>{{ 'NEW_CONTRACTS.BUSINESS_NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="socialReasonLabel" maxlength="70" />
        <mat-error
          *ngIf="
            businessNameForm?.controls.socialReasonLabel.errors?.required &&
            (businessNameForm.controls.socialReasonLabel.touched || businessNameForm.controls.socialReasonLabel.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        [ngClass]="{
          'multipoint-business-name-pymes__fix-label':
            (businessNameForm?.controls.cnae.errors?.required ||
              businessNameForm?.controls.cnae.errors?.invalid_cnae) &&
            !(businessNameForm.controls.cnae.touched || businessNameForm.controls.cnae.dirty)
        }"
      >
        <mat-label>{{ 'NEW_CONTRACTS.CNAE' | i18nextEager }}</mat-label>
        <input matInput formControlName="cnae" numeric [maxlength]="isUserSpanish ? 4 : 5" />
        <mat-error
          *ngIf="
            (businessNameForm?.controls.cnae.errors?.required ||
              businessNameForm?.controls.cnae.errors?.invalid_cnae) &&
            (businessNameForm.controls.cnae.touched || businessNameForm.controls.cnae.dirty)
          "
        >
          {{ (isUserSpanish ? 'NEW_CONTRACTS.CNAE_ERROR' : 'NEW_CONTRACTS.PT_CNAE_ERROR') | i18nextEager }}
        </mat-error>
      </mat-form-field>
    </form>
  </section>
  <section>
    <h2>{{ 'NEW_CONTRACTS.ADDRESS' | i18nextEager }}</h2>
    <form [formGroup]="businessNameForm">
      <app-custom-select
        class="width100"
        [required]="true"
        [label]="'NEW_CONTRACTS.ROAD_TYPE'"
        [controlName]="'roadType'"
        [values]="roadTypeList"
        [defaultValue]="this.businessNameForm.get('roadType').value"
        [searchBar]="true"
        [disabled]="this.businessNameForm.get('roadType').disabled"
      ></app-custom-select>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="roadName" maxlength="100" />
        <mat-error
          *ngIf="
            businessNameForm?.controls.roadName.errors?.required &&
            (businessNameForm.controls.roadName.touched || businessNameForm.controls.roadName.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <div class="tree-col">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</mat-label>
            <input matInput formControlName="addressNumber" maxlength="8" alphanumeric />
            <mat-error
              *ngIf="
                businessNameForm?.get('addressNumber').errors?.maxlength &&
                (businessNameForm?.get('addressNumber').touched || businessNameForm?.get('addressNumber').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.EIGHT_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !businessNameForm?.get('addressNumber').errors?.maxlength &&
                businessNameForm?.get('addressNumber').errors?.invalidInitialValue &&
                (businessNameForm?.get('addressNumber').touched || businessNameForm?.get('addressNumber').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</mat-label>
            <input matInput formControlName="gate" maxlength="10" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</mat-label>
            <input matInput formControlName="stair" maxlength="3" alphanumeric />
            <mat-error
              *ngIf="
                businessNameForm?.get('stair').errors?.maxlength &&
                (businessNameForm?.get('stair').touched || businessNameForm?.get('stair').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !businessNameForm?.get('stair').errors?.maxlength &&
                businessNameForm?.get('stair').errors?.invalidInitialValue &&
                (businessNameForm?.get('stair').touched || businessNameForm?.get('stair').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="tree-col">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</mat-label>
            <input matInput formControlName="floor" maxlength="3" alphanumeric />
            <mat-error
              *ngIf="
                businessNameForm?.get('floor').errors?.maxlength &&
                (businessNameForm?.get('floor').touched || businessNameForm?.get('floor').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !businessNameForm?.get('floor').errors?.maxlength &&
                businessNameForm?.get('floor').errors?.invalidInitialValue &&
                (businessNameForm?.get('floor').touched || businessNameForm?.get('floor').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</mat-label>
            <input matInput formControlName="door" maxlength="3" alphanumeric />
            <mat-error
              *ngIf="
                businessNameForm?.get('door').errors?.maxlength &&
                (businessNameForm?.get('door').touched || businessNameForm?.get('door').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !businessNameForm?.get('door').errors?.maxlength &&
                businessNameForm?.get('door').errors?.invalidInitialValue &&
                (businessNameForm?.get('door').touched || businessNameForm?.get('door').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field *ngIf="isUserSpanish" appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
            <input matInput formControlName="postalCode" />
            <mat-error
              *ngIf="
                businessNameForm?.controls.postalCode.errors?.required &&
                (businessNameForm.controls.postalCode.touched || businessNameForm.controls.postalCode.dirty)
              "
            >
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
          <div *ngIf="!isUserSpanish">
            <div class="multipoint-business-name-pymes__pt-postal-code-field">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                <input matInput formControlName="postalCodePT1" maxlength="4" />
              </mat-form-field>
              <p class="multipoint-business-name-pymes__postal-code-hyphen">
                {{ 'NEW_CONTRACTS.POSTAL_CODE_PT_HYPHEN' | i18nextEager }}
              </p>
              <mat-form-field appearance="outline">
                <input matInput formControlName="postalCodePT2" maxlength="3" />
              </mat-form-field>
            </div>
            <mat-error
              *ngIf="
                (
                  businessNameForm?.controls.postalCodePT1.errors?.required ||
                  businessNameForm?.controls.postalCodePT2.errors?.required
                ) &&
                (
                  businessNameForm.controls.postalCodePT1.touched ||
                  businessNameForm.controls.postalCodePT1.dirty ||
                  businessNameForm.controls.postalCodePT2.touched ||
                  businessNameForm.controls.postalCodePT2.dirty
                )
              "
              class="multipoint-business-name-pymes__pt-postal-code-error"
            >
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !businessNameForm?.controls.postalCodePT1.errors?.required &&
                !businessNameForm?.controls.postalCodePT2.errors?.required &&
                businessNameForm?.controls.postalCode.errors?.pattern &&
                (
                  businessNameForm.controls.postalCodePT1.touched ||
                  businessNameForm.controls.postalCodePT1.dirty ||
                  businessNameForm.controls.postalCodePT2.touched ||
                  businessNameForm.controls.postalCodePT2.dirty
                )
              "
              class="multipoint-business-name-pymes__pt-postal-code-error"
            >
              {{ 'NEW_CONTRACTS.POSTAL_CODE_ERROR' | i18nextEager }}
            </mat-error>
          </div>
        </div>
      </div>
      <ng-container *ngIf="townList.length <= 1; else selectTemplate">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</mat-label>
          <input matInput formControlName="town" maxlength="100" />
          <mat-error
            *ngIf="
              businessNameForm?.controls.town.errors?.required &&
              (businessNameForm.controls.town.touched || businessNameForm.controls.town.dirty)
            "
          >
            {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
          </mat-error>
        </mat-form-field>
      </ng-container>
      <ng-template #selectTemplate>
        <app-custom-select
          class="width100"
          [label]="'NEW_CONTRACTS.TOWN'"
          [controlName]="'town'"
          [values]="townList"
          [defaultValue]="this.businessNameForm.get('town').value"
          [disabled]="this.businessNameForm.get('town').disabled"
        >
          <mat-error
            *ngIf="
              businessNameForm?.controls.town.errors?.required &&
              (businessNameForm.controls.town.touched || businessNameForm.controls.town.dirty)
            "
          >
            {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
          </mat-error>
        </app-custom-select>
      </ng-template>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.PROVINCE' | i18nextEager }}</mat-label>
        <input
          matInput
          formControlName="province"
          maxlength="100"
          placeholder="{{ 'NEW_CONTRACTS.PROVINCE_EXAMPLE' | i18nextEager }}"
        />
        <mat-error
          *ngIf="
            businessNameForm?.controls.province.errors?.required &&
            (businessNameForm.controls.province.touched || businessNameForm.controls.province.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
    </form>
  </section>
  <section>
    <h2>{{ 'NEW_CONTRACTS.CONTACT' | i18nextEager }}</h2>
    <form [formGroup]="businessNameForm">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="contactName" maxlength="50" />
        <mat-error
          *ngIf="
            businessNameForm?.controls.contactName?.errors?.required &&
            (businessNameForm.controls.contactName.touched || businessNameForm.controls.contactName.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.SURNAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="surname" maxlength="50" />
        <mat-error
          *ngIf="
            businessNameForm?.controls.surname.errors?.required &&
            (businessNameForm.controls.surname.touched || businessNameForm.controls.surname.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.DNI_NIE' | i18nextEager }}</mat-label>
        <input
          matInput
          formControlName="dni"
          maxlength="9"
          placeholder="{{ isUserSpanish ? ('NEW_CONTRACTS.DNI_EXAMPLE' | i18nextEager) : '' }}"
        />
        <mat-error
          *ngIf="
            businessNameForm?.controls.dni.errors?.invalid_dni &&
            (businessNameForm.controls.dni.touched || businessNameForm.controls.dni.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.DNI_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.EMAIL' | i18nextEager }}</mat-label>
        <input
          matInput
          formControlName="email"
          placeholder="{{ 'NEW_CONTRACTS.EMAIL_EXAMPLE' | i18nextEager }}"
          maxlength="50"
        />
        <mat-error
          *ngIf="
            businessNameForm?.controls.email.errors?.required &&
            (businessNameForm.controls.email.touched || businessNameForm.controls.email.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
        <mat-error
          *ngIf="
            businessNameForm?.controls.email.errors &&
            businessNameForm?.controls.email.value &&
            (businessNameForm.controls.email.touched || businessNameForm.controls.email.dirty)
          "
        >
          {{ 'NEW_CONTRACTS.EMAIL_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <div class="multipoint-business-name-pymes__mobile-field">
        <div *ngIf="!isUserSpanish" class="multipoint-business-name-pymes__country-code">
          <app-custom-select
            [required]="true"
            [label]="'NEW_CONTRACTS.MOBILE_COUNTRY_CODE.LABEL'"
            [controlName]="'mobileCountryCode'"
            [values]="mobileCountryCodeList"
            [disabled]="businessNameForm.get('mobileCountryCode').disabled"
            [defaultValue]="businessNameForm.get('mobileCountryCode').value"
          ></app-custom-select>
        </div>
        <div class="multipoint-business-name-pymes__mobile-input">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.MOBILE' | i18nextEager }}</mat-label>
            <input matInput formControlName="mobile" maxlength="9" numeric />
            <mat-error
              *ngIf="
                (businessNameForm?.controls.mobile.errors?.required ||
                  businessNameForm?.controls.mobile.errors?.invalid_mobile) &&
                (businessNameForm.controls.mobile.touched || businessNameForm.controls.mobile.dirty)
              "
            >
              {{ 'NEW_CONTRACTS.MOBILE_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </section>
</div>
